import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

/**
 * PostGoodsActionBottomSheet 가 떠있는지 여부 (instanceId 별).
 * GoodsDetail.page 의 useHandleBackPressed 가 이 값을 보고 back press 를
 * 바텀시트(ui-kit BottomSheetContainer 의 BackHandler) 로 propagation 시킬지 결정한다.
 *
 * brownfield 에서 GoodsDetail 이 여러 인스턴스 마운트될 수 있어 atomFamily 로
 * instanceId 별 atom 분리. 같은 GoodsDetail 인스턴스의 set/read 만 일치하도록 함.
 *
 * 배경: BackHandler 는 LIFO + React effect children-first 라 GoodsDetail-A 의
 * useHandleBackPressed listener 가 stack top 차지. A 의 콜백이 항상 true 반환하면
 * propagation 차단 → 바텀시트 listener 호출 안 됨.
 */
export const isPostGoodsActionBottomSheetOpenAtomFamily = atomFamily(
  (_instanceId: string) => atom(false),
);
